import parse from 'html-react-parser';
import replaceNewLinesForHtml from '../../utils/replaceNewLines';
import _ from 'lodash';

export default function TextToHtml({text, wrap}) {
  if (!wrap) {
    wrap = (content) => content;
  }

  const options = {
    replace: (props) => {
      if (props.type === 'text') {
        return wrap(replaceNewLinesForHtml(props.data));
      }
    }
  };

  if (_.isNil(text) || text === '') {
    return wrap(null);
  }

  if (text) {
    return wrap(parse(text, options));
  }
}
